import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { flexCenter } from '../commonUI/cssClasses';
import { useWindowSize } from 'react-use';
import LoginForm from './LoginForm';
import ImageCarousel from './ImageCarousel';

const LoginPage: React.FC = () => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const { height } = useWindowSize();

  let maxCarouselWidth = '700px';
  if (height < 800) maxCarouselWidth = '550px';

  return (
    <Box
      sx={{
        width: '100%',
        height: '100vh',
        display: 'grid',
        gridTemplateRows: '1fr',
        gridTemplateColumns: `minmax(50%, 1fr) minmax(200px, ${maxCarouselWidth})`,
        gridTemplateAreas: `
          'loginArea photoArea'
        `,
        [theme.breakpoints.down('sm')]: {
          gridTemplateRows: '1fr',
          gridTemplateColumns: '1fr',
          gridTemplateAreas: `
          'loginArea'
        `,
        },
      }}
    >
      <Box sx={{ ...flexCenter, gridArea: 'loginArea' }}>
        <LoginForm />
      </Box>
      {!isSmall && (
        <Box sx={{ ...flexCenter, gridArea: 'photoArea' }}>
          <ImageCarousel />
        </Box>
      )}
    </Box>
  );
};

export default LoginPage;
